import Language from '../Language';

export default new Language(
	'English',
	[
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	],
	['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
);
// eslint-disable-next-line
